export default __webpack_public_path__ + "static/media/banner-spectator.b991cb83.png";